import Repository from "./Repository";

const resource = "/colors";

export default {
  fetchColors() {
    return Repository.get(resource).then(res => res.data);
  }
};
